import Vue from "vue";
import VueRouter from "vue-router";
import authRoutes from "./routes/auth-routes";
import exploreRoutes from "./routes/explore-routes";
import modelRoutes from "./routes/model-routes";
import pageRoutes from "./routes/page-routes";
import poolRoutes from "./routes/pool-routes";
import projectRoutes from "./routes/project-routes";
import userRoutes from "./routes/user-routes";
import realmRoutes from "./routes/realm-routes";
import store from "./store/store";

Vue.use(VueRouter);

const routes = [
  ...authRoutes,
  ...exploreRoutes,
  ...modelRoutes,
  ...pageRoutes,
  ...poolRoutes,
  ...projectRoutes,
  ...userRoutes,
  ...realmRoutes
];

const router = new VueRouter({
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  document.title = "Mynd – " + to.meta.title;
  if (to.matched.some(record => record.meta.public)) {
    next();
  } else {
    if (
      Vue.prototype.$authService.authenticated() &&
      Vue.prototype.$authService.tokenStillValid()
    ) {
      next();
    } else {
      Vue.prototype.$authService.redirectToLogin();
    }
  }
});


export default router;
